import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import BrowserWidthBucket from './BrowserWidthBucket';

interface MailLayoutStore {
    browserWidthBucket: BrowserWidthBucket;
    clientReadingPanePosition: ReadingPanePosition;
    showReadingPane: boolean;
    showListPane: boolean;
    showFolderPane: boolean;
}

export default MailLayoutStore;

export enum ListViewLayout {
    SingleLine,
    ThreeLine,
}
